import { render, staticRenderFns } from "./DriversSchedule.vue?vue&type=template&id=24d4bb96"
import script from "./DriversSchedule.vue?vue&type=script&lang=js"
export * from "./DriversSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports